import {global} from "../../../appContext";
import {StatusManager} from "./StatusManager";
import detailsHtml from './details.html?raw';

export const template = detailsHtml

export class viewModel {

    private readonly statusManager: StatusManager = new StatusManager({
        permission: global.permissionValidator.role,
    })

    constructor() {
        this.statusManager.init()
            .then(() => {
                const companySyncstepId = global.router.currentRoute()?.__routeParams?.['companysyncstepid']
                this.statusManager.mutableSyncCycle.showCompanySyncstep(companySyncstepId)
            })
    }

    dispose() {
        this.statusManager.dispose()
    }

}